const COOKIE_NAME = process.env.REACT_APP_ENV === 'staging' ? 'staging_vlab_active_org' : 'vlab_active_org'
const MAX_AGE = 60 * 60 * 24 * 30

export function readOrgCookie(): string {
  const row = document.cookie.split('; ').find((c) => c.startsWith(`${COOKIE_NAME}=`))
  if (!row) return ''
  try {
    return decodeURIComponent(row.slice(COOKIE_NAME.length + 1))
  } catch {
    return ''
  }
}

export function writeOrgCookie(code: string): void {
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(code)}; path=/; domain=.vlab.live; SameSite=Lax; max-age=${MAX_AGE}`
}
